export const DEMO_ERROR_CODE = 'DEMO_READ_ONLY'
export const DEMO_MESSAGE = '演示账号仅供浏览和交互体验，此操作不会执行，也不会保存真实数据。'

const localGatewayReads = new Set(['mc01', 'mc05', 'mc07', 'mc29', 'binding-status', 'capabilities', 'best', 'score-records'])

export function isDemoReadRequest(config = {}) {
  const method = String(config.method || 'get').toUpperCase()
  const path = new URL(config.url || '/', 'http://local.invalid').pathname.replace(/\/$/, '')
  if (method === 'POST' && path === '/auth/login') return true
  if (method === 'POST' && path === '/maimai/gateway') {
    let payload = config.data || {}
    if (typeof payload === 'string') {
      try { payload = JSON.parse(payload) } catch (_) { return false }
    }
    return localGatewayReads.has(payload.op || payload.action)
  }
  return ['GET', 'HEAD', 'OPTIONS'].includes(method) &&
    !/^\/(chipsnet-machines|judge-machines)\/[^/]+\/key$/.test(path) &&
    !/^\/access\/stores\/[^/]+\/locks$/.test(path) &&
    !/^\/stores\/my\/payment-orders\/[^/]+\/qr$/.test(path)
}

export function demoReadOnlyError(config) {
  const error = new Error(DEMO_MESSAGE)
  error.config = config
  error.response = { status: 403, data: { code: DEMO_ERROR_CODE, detail: DEMO_MESSAGE }, config }
  return error
}

export function isDemoRestriction(error) {
  return error && error.response && (error.response.data && error.response.data.code === DEMO_ERROR_CODE ||
    error.response.headers && error.response.headers['x-demo-read-only'] === '1')
}

export function presentationProfile(profile) {
  return profile && profile.role === 'demo' ? { ...profile, role: 'admin', account_role: 'demo', demo_read_only: true } : profile
}
